import { useCallback, useEffect } from 'react';

import { request } from 'app/utils';
import { AvailableClassesApiResponse, ProductsSidebarButton, ProductsSidebarInterestButton, useProducts } from 'features/products';
import { useSchool } from 'features/school';

interface EnrollmentProps {
  productSlug: string;
  fetchJourney: (forceEnroll: boolean) => void;
}

const Enrollment = ({ productSlug, fetchJourney }: EnrollmentProps) => {
  const { productDetails, availableClasses, setAvailableClasses, clearAvailableClasses } = useProducts();

  const { apiGatewayUrl } = useSchool();

  const fetchAvailableClasses = useCallback(async () => {
    await Promise.all([
      request<AvailableClassesApiResponse>({
        url: `/api/v1/School/AvailableClasses/${productSlug}`,
        method: 'get',
        baseURL: apiGatewayUrl,
      }).then(({ data }) => {
        setAvailableClasses(data);
      }),
    ]);
  }, [productSlug]);

  useEffect(() => {
    fetchAvailableClasses();
  }, [productSlug]);

  useEffect(() => {
    return () => {
      clearAvailableClasses();
    };
  }, []);

  return (
    <>
      {availableClasses?.current?.allowEnrollments &&
        (productDetails?.allowOnDemandEnrollments ? (
          <ProductsSidebarButton onClick={() => fetchJourney(true)} label="Matricular agora" type="nolink" to="" borderRadiusTop />
        ) : (
          <ProductsSidebarInterestButton label={`Tenho interesse nessa Jornada`} labelMobile="Tenho interesse" bordered />
        ))}
    </>
  );
};

export default Enrollment;
